import React, { useEffect, useState, useRef } from "react";
import Header from "./Header";
import fire from "./Firebase";
import "../App.css";
import { useReactToPrint } from "react-to-print";
import { toast } from "react-toastify";
import * as htmlToImage from "html-to-image";
import Footer from "../Footer";

function Try() {
  const conponentPDF = useRef();
  const domEl = useRef({});
  const downloadImage = async () => {
    const dataUrl = await htmlToImage.toJpeg(domEl.current);

    // download image
    const link = document.createElement("a");
    link.download = "html-to-img.jpeg";
    link.href = dataUrl;
    link.click();
  };
  const [usercertificate, setusercertificate] = useState([]);
  const [usercertificate1, setusercertificate1] = useState([]);

  useEffect(() => {
    fire
      .child(`certificates/${sessionStorage.getItem("lastname")}`)
      .on("value", (sna) => {
        setusercertificate([sna.val()]);
      });
  }, []);
  // useEffect(() => {
  //   fire
  //     .child(`excelcerti/${sessionStorage.getItem("lastname2")}`)
  //     .on("value", (sna) => {
  //       setusercertificate1([sna.val()]);
  //     });
  // }, []);

  // const generatePDF = useReactToPrint({
  //   content: () => conponentPDF.current,
  //   documentTitle: "Userdata",
  //   onAfterPrint: () => toast("Data saved in PDF"),
  // });
  // const generatePDF2 = useReactToPrint({
  //   content: () => conponentPDF.current,
  //   documentTitle: "Userdata",
  //   onAfterPrint: () => toast("Data saved in PDF"),
  // });
  console.log(usercertificate.Course);
  return (
    <div>
      <Header />
      <center>
        <div ref={conponentPDF}>
          {usercertificate.map((data) => {
            console.log(data.Course);
            return (
              <>
                <div className="print" id="certificateboxs" ref={domEl}>
                  <div
                    style={{
                      width: "100%",
                      height: "100%",
                      padding: "20px",
                      textalign: "center",
                      border: "10px solid #787878",
                      textTransform:"uppercase"
                    }}
                  >
                    <div
                      style={{
                        width: "100%",
                        height: "100%",
                        padding: "20px",
                        textalign: "center",
                        border: "5px solid #787878",
                        backgroundColor: "lightsalmon",
                      }}
                    >
                      <center>
                        {" "}
                        <div>LOKI SCHOOL</div>
                        <hr class="accessory" />
                        <span style={{ fontSize: "18px", fontWeight: "bold" }}>
                          CERTIFICATE OF COMPLETION
                        </span>
                        <br />
                        <br />
                        <span style={{ fontSize: "12px" }}>
                          <i>CERTIFIED {data.Field} SPECIALIST</i>
                        </span>
                        <br />
                        <br />
                        <span style={{ fontSize: "18px" }}>
                          <b>THIS IS TO CERTIFY THAT</b>
                        </span>
                        <br />
                        <br />
                        <span style={{ fontsize: "20px" }}>
                          <b>
                            NAME :-{data.Gender} {data.Name}{" "}
                          </b>
                        </span>{" "}
                        <br />
                        <span style={{ fontsize: "20px" }} class="father">
                          <b>FATHER NAME :- {data.Father}</b>
                        </span>
                        <br />
                        <span style={{ fontsize: "20px" }}>
                          <b>COURSE DURATION :- {data.Course} MONTHS</b>
                        </span>{" "}
                        <br />
                        <span style={{ fontsize: "20px" }} class="father">
                          <b>COURSE NAME :- {data.Coursename}</b>
                        </span>
                        <br />
                        <br />
                        <span style={{ fontsize: "25px" }}>
                          <i>
                            THE BEAUTIFUL THING ABOUT LEARNING IS THAT NO ONE
                            CAN TAKE IT AWAY FROM YOU.
                          </i>
                        </span>
                        <br />
                        <br />
                        <span style={{ fontWeight: "bold" }}>
                          HAS SUCCESSFULLY COMPLETED THE {data.Coursename}{" "}
                          COURSE WITH LOKI SCHOOL
                        </span>{" "}
                        <br />
                        <br />
                        <span style={{ fontsize: "20px" }}>
                          WITH SCORE OF <b>{data.grade}</b>
                        </span>
                        <br />
                        <span style={{ fontsize: "25px" }}>
                          <i>DATED</i>
                        </span>
                        <br />
                        <span style={{ fontsize: "30px" }}>
                          START DATE :- {data.startdate}/{data.startmonth}/{data.startyear}
                        </span>{" "}
                        <br />
                        <span style={{ fontsize: "30px" }}>
                          END DATE :- {data.enddate}/{data.endmonth}/{data.endyear}
                        </span>
                        <br />
                        <br />
                        <span style={{ fontsize: "25px" }} class="website">
                          <i>www.hrschool.com</i>
                        </span>
                        <br />
                      </center>
                    </div>
                  </div>
                  <center>
                    {" "}
                    <br />
                  </center>
                </div>
              </>
            );
          })}
        </div>
      </center>
      <center>
        {/* <button className="non-printable" onClick={() => generatePDF()}>
          Convert In PDF
        </button> */}
         <button onClick={downloadImage} style={{ color: "black" }}>
          Download Image
        </button>
      </center>
      {/* {usercertificate1.map((all) => {
        return (
          <>
            <div className="print">
              <div
                style={{
                  width: "100%",
                  height: "100%",
                  padding: "20px",
                  textalign: "center",
                  border: "10px solid #787878",
                }}
              >
                <div
                  style={{
                    width: "100%",
                    height: "100%",
                    padding: "20px",
                    textalign: "center",
                    border: "5px solid #787878",
                    backgroundColor: "lightsalmon",
                  }}
                >
                  <center>
                    {" "}
                    <div>HR SCHOOL</div>
                    <hr class="accessory" />
                    <span style={{ fontSize: "18px", fontWeight: "bold" }}>
                      CERTIFICATE OF COMPLETION
                    </span>{" "}
                    <br />
                    <br />
                    <span style={{ fontSize: "12px" }}>
                      <i>CERTIFIED {all.Field} SPECIALIST</i>
                    </span>
                    <br />
                    <br />
                    <span style={{ fontSize: "18px" }}>
                      <b>THIS IS TO CERTIFY THAT</b>
                    </span>
                    <br />
                    <br />
                    <span style={{ fontsize: "20px" }}>
                      <b>
                        NAME :- {all.Gender}. {all.Name}{" "}
                      </b>
                    </span>{" "}
                    <br />
                    <span style={{ fontsize: "20px" }} class="father">
                      <b>FATHER NAME :- {all.Father}</b>
                    </span>
                    <br />
                    <span style={{ fontsize: "20px" }}>
                      <b>COURSE DURATION :- {all.Course}</b>
                    </span>{" "}
                    <br />
                    <span style={{ fontsize: "20px" }} class="father">
                      <b>COURSE NAME :- {all.Coursename}</b>
                    </span>
                    <br />
                    <br />
                    <span style={{ fontsize: "25px" }}>
                      <i>
                        THE BEAUTIFUL THING ABOUT LEARNING IS THAT NO ONE CAN
                        TAKE IT AWAY FROM YOU.
                      </i>
                    </span>
                    <br />
                    <br />
                    <span style={{ fontWeight: "bold" }}>
                      HAS SUCCESSFULLY COMPLETED THE {all.Coursename} COURSE
                      WITH HR SCHOOL
                    </span>{" "}
                    <br />
                    <br />
                    <span style={{ fontsize: "20px" }}>
                      WITH SCORE OF <b>{all.grade}</b>
                    </span>
                    <br />
                    <span style={{ fontsize: "25px" }}>
                      <i>DATED</i>
                    </span>
                    <br />
                    <span style={{ fontsize: "30px" }}>
                      START DATE :- {all.startdate}/{all.startmonth}/
                      {all.startyear}
                    </span>{" "}
                    <br />
                    <span style={{ fontsize: "30px" }}>
                      END DATE :- {all.enddate}/{all.endmonth}/{all.endyear}
                    </span>
                    <br />
                    <br />
                    <span style={{ fontsize: "25px" }} class="website">
                      <i>www.hrschool.com</i>
                    </span>
                    <br />
                  </center>
                </div>
              </div>
              <center>
                {" "}
                <br />
                <button onClick={() => generatePDF2(all)}>
                  Convert In PDF
                </button>
              </center>
            </div>
          </>
        );
      })} */}
      <Footer/>
    </div>
  );
}

export default Try;
